import { Tooltip, UnstyledButton, VisuallyHidden } from "@mantine/core";
import { X } from "lucide-react";

import { ANALYSING } from "../ad-copies/use-ad-structures";
import type { SourceView } from "../composer/source";
import classes from "./image.module.css";

export interface SourceThumbProps {
  view: SourceView;
  removeLabel: string;
  onRemove: () => void;
  /** The Advanced mode analyses it: washed out, with live's "Analysing..." (capture studio-depth 27). */
  analysing?: boolean;
}

/**
 * A chosen reference under the prompt, as live's (captures 17, 18, 22, 22b): a small square
 * picture with a round remove control on its corner, shown on hover and on focus. The row
 * around the pictures is the composer's.
 */
export function SourceThumb({ view, removeLabel, onRemove, analysing = false }: SourceThumbProps) {
  return (
    <Tooltip label={ANALYSING} withArrow disabled={!analysing}>
      <span className={classes.thumb} data-analysing={analysing || undefined}>
        {view.url === null ? (
          <span className={classes.thumbPicture}>
            <VisuallyHidden>{view.name}</VisuallyHidden>
          </span>
        ) : (
          <img src={view.url} alt={view.name} className={classes.thumbPicture} />
        )}
        {analysing ? <VisuallyHidden>{ANALYSING}</VisuallyHidden> : null}
        <UnstyledButton className={classes.thumbRemove} aria-label={removeLabel} onClick={onRemove}>
          <X size={12} strokeWidth={2.5} aria-hidden />
        </UnstyledButton>
      </span>
    </Tooltip>
  );
}
